import React, { useState, useEffect } from "react";
import { User } from "../../../../api";
import { Loader, Dropdown } from "semantic-ui-react";
import { map, size, filter } from "lodash";
import { useAuth } from "../../../../hooks";
import { UserItem } from "../UserItem/UserItem";

const usercontroller = new User();

const roleOptions = [
  { key: "all", value: "all", text: "Todos los roles" },
  { key: "admin", value: "admin", text: "Administrador" },
  { key: "user", value: "user", text: "Usuario" },
  { key: "client", value: "client", text: "Cliente" },
  { key: "partner", value: "partner", text: "Partner" },
  { key: "teacher", value: "teacher", text: "Profesor" },
  { key: "student", value: "student", text: "Alumno" },
  { key: "institution", value: "institution", text: "Institución" }, 
];

export function ListUsers(props) {
  const { userActive, reload, onReload } = props;
  const [users, setUsers] = useState(null);
  const [selectedRole, setSelectedRole] = useState("admin");
  const { accessToken } = useAuth();

  useEffect(() => {
    (async () => {
      try {
        setUsers(null);
        const response = await usercontroller.getUsers(accessToken, userActive);
        if (response.users && response.users.length > 0) {
          setUsers(response.users);
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error(error);
      }
    })();
  }, [userActive, reload, accessToken]);

  const handleRoleChange = (_, { value }) => {
    setSelectedRole(value);
  };

  const filteredUsers =
    selectedRole === "all"
      ? users
      : filter(users, (user) => user.role === selectedRole);

  if (!users) {
    return <Loader active inline="centered" />;
  }

  return (
    <>
      {/* Dropdown para seleccionar el rol */}
      <Dropdown
        placeholder="Selecciona un rol"
        fluid
        selection
        options={roleOptions}
        onChange={handleRoleChange}
        value={selectedRole}
        style={{ marginBottom: "1em" }}
      />

      {/* Mostrar mensaje si no hay usuarios para el rol seleccionado */}
      {size(filteredUsers) === 0 ? (
        <p>No hay usuarios para el rol seleccionado</p>
      ) : (
        map(filteredUsers, (user) => (
          <UserItem key={user._id} user={user} onReload={onReload} />
        ))
      )}
    </>
  );
}

